import { render, staticRenderFns } from "./disenar_documentos.vue?vue&type=template&id=7be36efc&"
import script from "./disenar_documentos.vue?vue&type=script&lang=js&"
export * from "./disenar_documentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports